import { render } from "./HomeStudent.vue?vue&type=template&id=250c2d53"
import script from "./HomeStudent.vue?vue&type=script&lang=js"
export * from "./HomeStudent.vue?vue&type=script&lang=js"

import "./HomeStudent.vue?vue&type=style&index=0&id=250c2d53&lang=scss"

import exportComponent from "D:\\angren\\admit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__